import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

let URL = "https://benefacto-backend.developer-ourbase-camp.com/api/";

export const EarthActionApi = createAsyncThunk("earth/detail", async () => {
	try {
		const { data } = await axios.get(`${URL}earth-section/get-earth-section`);
		return data;
	} catch (err) {
		return err.message;
	}
});
